import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { LocaleService } from './locale.service';
import { GLOBAL_REGION } from './settings-constants';


export const localeRedirectGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree> => {
  const locale = inject(LocaleService);
  const router = inject(Router);

  return locale.optimalStartPageLocale.pipe(
    first(),
    map((locale) => {
      if (!locale.region || locale.region === GLOBAL_REGION) {
        return [locale.language];
      } else {
        return [locale.language, locale.region.toLowerCase()];
      }
    }),
    map((commands) => {
      const command = [...commands, ...route.url.map(part => part.path)];
      const url = new URL(state.url, 'https://fakebase');

      let queryParams = null;
      if (url.search) {
        queryParams = {} as Params;
        for (const [key, value] of url.searchParams.entries()) {
          if (key in queryParams) {
            const currentValue = queryParams[key];
            if (Array.isArray(currentValue)) {
              currentValue.push(value);
            } else {
              queryParams[key] = [currentValue, value];
            }
          } else {
            queryParams[key] = value;
          }
        }
      }

      return router.createUrlTree(command, {
        fragment: url.hash ? url.hash.substring(1) : undefined,
        queryParams: queryParams,
      });
    }),
  );
}
